import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string, duration: number = 30000): void {
    this.snackBar.open(message, 'Cerrar', {
      duration,
      panelClass: ['snackbar-success'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  showError(message: string, duration: number = 60000): void {
    this.snackBar.open(message, 'Aceptar', {
      duration,
      panelClass: ['snackbar-error'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  showInfo(message: string, duration: number = 60000): void {
    this.snackBar.open(message, 'Cerrar', {
      duration,
      panelClass: ['snackbar-info'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }
}
